import nxModule from 'nxModule';

const templateUrl = require('./holiday-branches.template.html');

nxModule.component('holidayBranches', {
  templateUrl,
  controller: function () {
  }
});
